exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-card--reveal[data-v-a9ceb71a] {\n  align-items: center;\n  bottom: 0;\n  justify-content: center;\n  padding: 0 15px;\n  opacity: 1;\n  position: absolute;\n  width: 100%;\n}\n", ""]);

// exports
